/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-02 17:18:22
 * @LastEditors: caiqin.xie
 * @message: 当前博客的相关博客
 */
import React from "react";
import BlogItem from "../../../components/BlogItem";
import styles from "../../index.module.scss";
import { IBlogItem } from "@/common/types";

interface IProps {
  ctry: string;
  words: Record<string, string>;
  device: string;
  title: string;
  relatedList: IBlogItem[]; // 相关博客
}

const RelatedArticles = (props:IProps) => {
  const {ctry, words, device, title, relatedList} = props

  return (
    <>
      {relatedList && relatedList.length > 0 && (
        <div className={styles['related-articles']}>
          <div className={styles['related-articles-title']}>
            <h3>{words?.blog_related_title}</h3>
            {/* Related Articles */}
            {device !== 'mobile' && relatedList && relatedList.length >= 3 && (
              <a href={`/${ctry}/blog/search/?keyword=${title}`}>
                <span className={styles['more-blog']}>{words?.common_learn_more}</span>
                {/* Learn More */}
              </a>
            )}
          </div>
          <div className={styles['related-articles-content']}>
            {relatedList.map((item, index) => (
              <a key={item.id} href={`/${ctry}/blog/${item.seoUrl}`} target="_self" className={styles['link-blog']}>
                <BlogItem
                  key={item.id}
                  type='onlyTitle'
                  blogData={item}
                  className={styles['custom-blog']}
                  picClassName={styles['custom-blog-pic']}
                  itemClassName={styles['custom-blog-item']} />
              </a>
            ))}
          </div>
          {device === 'mobile' && relatedList && relatedList.length >= 3 && (
            <p className={styles['more-blog-wrap']}>
              <a href={`/${ctry}/blog/search?keyword=${title}`}>
                <span className={styles['more-blog']}>{words?.common_learn_more}</span>
                {/* Learn More */}
              </a>
            </p>
          )}
        </div>
      )}
    </>
  )
}
export default RelatedArticles
